<template>
  <section class="navbar">
    <nav class="navbar__section">
      <ul
        :class="{ 'no-margin-last-child': !hasActivePhysicalUserCard }"
        class="navbar__list a-font__nav"
      >
        <li
          v-for="(item, index) in navbarItems"
          :key="`navitem_${index}`"
          class="navbar__item"
        >
          <router-link
            :key="index"
            class="navbar__link"
            :class="{ main: index === 0 }"
            :to="item.path"
          >
            {{ $t(item.title) }}
          </router-link>
        </li>
      </ul>
    </nav>
    <BaseDialog
      v-model="visible"
      close
    >
      <PInvitation @close="popupClose" />
    </BaseDialog>
    <BaseDialog
      v-model="tokenOut"
      close
    >
      <section class="navbar__popup">
        <h3 class="a-font__h3">
          Пока не работает =(
        </h3>
        <p class="a-font__l">
          Данная функция вскоре будет доступна 😇
        </p>
      </section>
    </BaseDialog>
  </section>
</template>

<script lang="ts">
import PInvitation from '@/projects/people/components/popups/p_invitation/p_invitation.vue';
import { useDialog } from '@/shared/composition/useDialog';
import BaseDialog from '@/shared/lib/uikit/components/BaseDialog/BaseDialog.vue';
import { useAuthStore } from '@/shared/store/useAuthStore';
import { useUserStore } from '@/shared/store/useUserStore';
import {
  defineComponent,
  watch,
} from 'vue';
import {
  useRouter,
  useRoute,
} from '@intlify/vue-router-bridge';
import './TheNavbar.scss';

export default defineComponent({
  name: 'NavBar',
  components: { BaseDialog, PInvitation },
  setup(_props) {
    const userStore = useUserStore();
    const { hasActivePhysicalUserCard } = userStore;
    const $router = useRouter();
    const $route = useRoute();
    const routerItems = $router.options.routes || [];
    const navbarItems = routerItems.filter(
      // @ts-ignore
      item => item.isInNavbar && (item?.isAllowWithoutUserCard ? true : !!hasActivePhysicalUserCard),
    );
    const authStore = useAuthStore();

    const logout = authStore.logoutFromKC;

    const { isVisible: isVisibleOnMobile, toggle: toggleMobileMenu } = useDialog();

    watch(
      () => $route,
      () => {
        isVisibleOnMobile.value = false;
      },
    );

    return {
      logout,
      isVisibleOnMobile,
      hasActivePhysicalUserCard,
      toggleMobileMenu,
      navbarItems,
    };
  },

  data() {
    return {
      tokenOut: false,
      visible: false,
    };
  },
  methods: {
    popupClose() {
      this.visible = false;
      this.tokenOut = false;
    },
  },
});
</script>
